import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";

const testService = {
    getTests(page, filters = []) {
        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');

            return axios.get(`/v1/admin/test/store?limit=20&page=${page}${tempFilters}`);
        } else {
            return axios.get(`/v1/admin/test/store?limit=20&page=${page}`);
        }
    },

    getCompanyTests(page, company, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&companyId=${company}&type=test`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/company/getAssigned?${queryParams}`);
    },

    getAllTests(types=null) {
        let params = {
            list:true
        }
        if (types && types.length > 0) {
            types.forEach(function (type) {
                if (!params.types) {
                    params.types = [];
                }
                params.types.push(type);
            })
        }
        return axios.get('/v1/admin/test/store', {params});
    },

    getCopy(testId) {
        return axios.post('/v1/admin/test/copy', {
            testId: testId
        });
    },

    addTest(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post('/v1/admin/test/add', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    updateTest(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post('/v1/admin/test/update', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    getTestDetail(id, lang = 'tr') {
        return axios.get(`/v1/admin/test/getFromId/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    getTestList(params = {}) {
        return axios.get('/v1/admin/test/list', { params });
    },

    getQuestion(id, type = 'test') {
        return axios.get(`/v1/admin/test/questionsList/${id}?type=${type}`);
    },

    assignTest(data) {
        return axios.post('/v1/admin/test/assign', data);
    },

    convertBooleanValuesToNumbers(data) {
        const convertValue = (value) => {
            if (typeof value === 'boolean') {
                return value ? 1 : 0;
            }
            if (typeof value === 'object') {
                for (const key in value) {
                    if (value.hasOwnProperty(key)) {
                        value[key] = convertValue(value[key]);
                    }
                }
            }
            return value;
        };

        return convertValue(data);
    },

    sendReport(journeyId, testId) {
        let data = {
            journeyId: journeyId,
            testId: testId,
        };
        return axios.post(`/v1/admin/journey/test/notification`, data);
    },

    deleteTest(id) {
        return axios.delete(`/v1/admin/test/delete/${id}`);
    },

    deleteTestAssign(data) {
        return axios.post('/v1/admin/test/assign/delete', data);
    },

    getSurveyList(id) {
        return axios.get('/v1/admin/test/answerList?testId=' + id);
    },

    getUserTests(page, userId, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&userId=${userId}&type=test`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/user/getAssigned?${queryParams}`);
    },

    getAssignedTests(userId, type = 'test') {
        return axios.get('/v1/admin/user/getAssigned', {
            params: {
                userId,
                type
            }
        });
    }
}

export default testService;
